/**
 * 环境变量配置
 */

export const config = {
    // API配置
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000',
    socketUrl: import.meta.env.VITE_SOCKET_URL || 'http://localhost:5000',

    // 静态文件配置
    staticBaseUrl: import.meta.env.VITE_STATIC_BASE_URL || 'http://localhost',

    // 应用配置
    appName: import.meta.env.VITE_APP_NAME || 'AI数理化助手',
    appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',

    // 开发配置
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    devMode: import.meta.env.VITE_DEV_MODE === 'true',
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
} as const;

/**
 * 构建完整的静态文件URL
 * @param path 相对路径
 * @param bustCache 是否添加缓存破坏参数（用于头像等需要及时更新的资源）
 */
export const buildStaticUrl = (path: string, bustCache: boolean = false): string => {
    if (path.startsWith('http')) {
        return path;
    }

    // 确保路径以 / 开头
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    // 始终使用完整URL，确保图片能正确加载
    const fullUrl = `${config.staticBaseUrl}${normalizedPath}`;

    // 添加缓存破坏参数（用于头像等需要及时更新的资源）
    if (bustCache) {
        const timestamp = Date.now();
        const separator = fullUrl.includes('?') ? '&' : '?';
        return `${fullUrl}${separator}v=${timestamp}`;
    }

    return fullUrl;
};

/**
 * 构建完整的API URL
 */
export const buildApiUrl = (path: string): string => {
    if (path.startsWith('http')) {
        return path;
    }

    // 确保路径以 / 开头
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return `${config.apiBaseUrl}${normalizedPath}`;
};

export default config;